import { createStoreon } from "storeon";
import { playersLanes } from "./players";
import { isHideDelay } from "./hideDelays";
import { scoreCardSettings } from "./scoreCardSettings";
import { tableSettings } from "./tableSettings";
import { generalSettings } from "./generalSettings";
import { changeSetupType } from "./setupType";
import { auth } from "./auth";
import { mainHeaderSettings } from "./mainHeaderSettings";
import { timersScoreCards } from "./timersScoreCards";
import { loggedInUserProfile } from "./loggedInUserProfile";
import { storeonDevtools } from 'storeon/devtools';

export const store = createStoreon([
  playersLanes,
  isHideDelay,
  scoreCardSettings,
  tableSettings,
  generalSettings,
  changeSetupType,
  auth,
  mainHeaderSettings,
  timersScoreCards,
  loggedInUserProfile,
  process.env.NODE_ENV !== 'production' && storeonDevtools
]);
